// extracted by mini-css-extract-plugin
export default {"userPhoto":"PhotoPage_userPhoto__oU3gS"};